import React, { useMemo } from 'react'
import { Text } from '@afterpaytouch/core'
import { InlinePaymentMethod } from '../../../../component/InlinePaymentMethod/InlinePaymentMethod'
import { SectionHeader } from '../../../../component'
import { useTranslation } from '../../../../utils/convergence'
import { useCheckoutSizes } from '../../../../utils/responsive'
import styles from './style.module.css'
import { useSummaryDetailsViewModel } from '../../hooks/useSummaryDetailsViewModel'

export const PaymentMethod = (): JSX.Element => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const { totalDueTodayAmount } = useSummaryDetailsViewModel()

  const isTotalDueTodayAmountGreaterThanZero = useMemo(() => {
    return parseFloat(totalDueTodayAmount.amount) > 0
  }, [totalDueTodayAmount])

  return (
    <>
      <SectionHeader title={t('summary:payment')} />
      {isTotalDueTodayAmountGreaterThanZero && (
        <Text size={textSize} color='Gray50' className={styles.paymentMethodMessage}>
          {t('summary:paymentMethodMessage')}
        </Text>
      )}
      <InlinePaymentMethod />
    </>
  )
}
